module.exports = __webpack_public_path__ + "img/xuexiao3.13fc8eed.png";